/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { ClientGoalRevisionDto } from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN**<br /><br />
 */
export const getClientGoalRevisions = (
  userId: string,
  clientId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ClientGoalRevisionDto[]>(
    {
      url: `/api/${userId}/clients/${clientId}/goals/${id}/revisions`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetClientGoalRevisionsQueryKey = (
  userId: string,
  clientId: number,
  id: number
) => {
  return [`/api/${userId}/clients/${clientId}/goals/${id}/revisions`] as const;
};

export const getGetClientGoalRevisionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientGoalRevisions>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientGoalRevisions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClientGoalRevisionsQueryKey(userId, clientId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClientGoalRevisions>>
  > = ({ signal }) =>
    getClientGoalRevisions(userId, clientId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && clientId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientGoalRevisions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientGoalRevisionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientGoalRevisions>>
>;
export type GetClientGoalRevisionsQueryError = ErrorType<unknown>;

export function useGetClientGoalRevisions<
  TData = Awaited<ReturnType<typeof getClientGoalRevisions>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientGoalRevisions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientGoalRevisions>>,
          TError,
          Awaited<ReturnType<typeof getClientGoalRevisions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientGoalRevisions<
  TData = Awaited<ReturnType<typeof getClientGoalRevisions>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientGoalRevisions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientGoalRevisions>>,
          TError,
          Awaited<ReturnType<typeof getClientGoalRevisions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientGoalRevisions<
  TData = Awaited<ReturnType<typeof getClientGoalRevisions>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientGoalRevisions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClientGoalRevisions<
  TData = Awaited<ReturnType<typeof getClientGoalRevisions>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientGoalRevisions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClientGoalRevisionsQueryOptions(
    userId,
    clientId,
    id,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
